<template>
  <div class="content">
    <div class="page-inner">
      <h1 class="mb-4">
        AI <span class="text-primary fw-bold">Lyric</span> Generator
      </h1>

      <div>
        <ul class="nav nav-pills nav-secondary nav-pills-no-bd" id="pills-tab-without-border" role="tablist">
          <li class="nav-item" @click="tab = 'create'">
            <a class="nav-link" :class="{ active: tab === 'create' }" id="pills-home-tab-nobd" data-toggle="pill" href="#pills-home-nobd" role="tab" aria-controls="pills-home-nobd" aria-selected="true">
              {{ $t('create') }}
            </a>
          </li>
          <li class="nav-item" @click="tab = 'myLyrics'">
            <a class="nav-link" :class="{ active: tab === 'myLyrics' }" id="pills-profile-tab-nobd" data-toggle="pill" href="#pills-profile-nobd" role="tab" aria-controls="pills-profile-nobd" aria-selected="false">
              {{ $t('my_lyrics') }}
            </a>
          </li>
          <!-- <li class="nav-item" @click="tab = 'explore'">
            <a class="nav-link" :class="{ active: tab === 'explore' }" id="pills-contact-tab-nobd" data-toggle="pill" href="#pills-contact-nobd" role="tab" aria-controls="pills-contact-nobd" aria-selected="false">
              Explore
            </a>
          </li> -->
        </ul>
      </div>

      <div v-if="tab === 'create'">
        <div>
          <div class="mt-3">
            <div class="text-right mb-2">
              {{ monthlyLyrics }} {{ $t('of') }} {{ maxLyrics }} {{ $t('lyrics_available') }}
              <router-link to="/upgrade" class="btn btn-sm btn-primary ml-1" v-if="!user.subscription">{{ $t('upgrade_to_pro') }}</router-link>
              <span class="badge badge-success ml-1" v-if="user.subscription">PRO</span>
            </div>
            <div class="progress progress-sm">
              <div class="progress-bar bg-info" role="progressbar" :style="`width: ${progress}%;`" aria-valuenow="" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
          </div>

          <!-- <div class="text-center mb-2 mt-2" v-if="!user.subscription">
            <ins class="adsbygoogle"
                style="display:block"
                data-ad-client="ca-pub-8326584585992829"
                data-ad-slot="8454890613"
                data-ad-format="auto"
                data-full-width-responsive="true"></ins>
          </div> -->

          <div class="card mt-4">
            <div class="card-body">
              <div class="form-group">
                <div class="h3 fw-thin">
                  {{ $t('ai_title_description') }}
                </div>
              </div>
              <div class="form-group">
                <label for="">{{ $t('language') }}</label>
                <select class="form-control" v-model="lyric.language">
                  <option value="spanish">Español</option>
                  <option value="english">English</option>
                  <option value="turkish">Turkish</option>
                  <option value="portuguese">Portuguese</option>
                </select>
              </div>
              <div class="form-group">
                <label for="">{{ $t('genre') }}</label>
                <select class="form-control" v-model="lyric.genre">
                  <option value="rock">Rock</option>
                  <option value="pop">Pop</option>
                  <option value="electronic">Electronic</option>
                  <option value="hip-hop">Hip Hop</option>
                  <option value="punk">Punk</option>
                  <option value="trap">Trap</option>
                  <option value="reggaeton">Reggaeton</option>
                  <option value="ska">Ska</option>
                  <option value="reggae">Reggae</option>
                  <option value="metal">Metal</option>
                  <option value="death metal">Death Metal</option>
                  <option value="regional mexican">Regional Mexicano</option>
                </select>
              </div>
              <div class="form-group">
                <label for="">{{ $t('mood') }}</label>
                <select class="form-control" v-model="lyric.mood">
                  <option value="happy">{{ $t('happy') }}</option>
                  <option value="in love">{{ $t('in_love') }}</option>
                  <option value="sad">{{ $t('sad') }}</option>
                  <option value="angry">{{ $t('angry') }}</option>
                  <option value="depressed">{{ $t('depressed') }}</option>
                  <option value="euphoric">{{ $t('euphoric') }}</option>
                  <option value="energic">{{ $t('energic') }}</option>
                  <option value="aggressive">{{ $t('aggresive') }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="">{{ $t('with_chorus') }} <router-link to="/upgrade" class="badge badge-success ml-1">PRO</router-link></label>
                <select class="form-control" v-model="lyric.chorus" :disabled="!user.subscription">
                  <option value="yes">{{ $t('yes') }}</option>
                  <option value="no">{{ $t('no') }}</option>
                </select>
              </div>
              <form class="form-group" @submit.prevent="addWord()">
                <label for="">{{ $t('include_custom_words') }} (Max. 4) <router-link to="/upgrade" class="badge badge-success ml-1">PRO</router-link></label>
                <div class="input-group">
                  <input v-model="word" type="text" :disabled="!user.subscription" class="form-control" placeholder="(Optional)" aria-label="" aria-describedby="basic-addon1">
                  <div class="input-group-append">
                    <button type="submit" :disabled="!user.subscription" class="btn btn-primary">
                      {{ $t('add') }}
                    </button>
                  </div>
                </div>
                <div class="mt-3">
                  <span class="badge badge-default mr-2 mb-2" v-for="(_word, index) in lyric.words" v-bind:key="`word_${index}`">
                    {{ _word }} <i class="fa fa-times ml-1" @click="removeWord(index)"></i>
                  </span>
                </div>
              </form>
              <div class="form-group">
                <label for="">{{ $t('dedicated_to') }}</label>
                <input v-model="lyric.dedicated" type="text" class="form-control" placeholder="(Optional)">
              </div>
            </div>
            <div class="card-footer" v-if="monthlyLyrics >= maxLyrics">
              <p>
                {{ $t('no_more_lyrics_available') }}
              </p>
            </div>
            <div class="card-footer" v-if="monthlyLyrics < maxLyrics">
              <div class="form-group" v-if="!hasPublishedMusic">
                <p class="alert alert-warning mb-1">{{ $t('release_published_needed') }}</p>
              </div>
              <div class="form-group">
                <button v-if="(user.subscription || (!user.subscription && hasPublishedMusic)) && !creating" type="button" @click="createLyrics()" class="btn btn-lg btn-gradient">
                  {{ $t('create_song') }}
                </button>
                <button type="button" class="btn btn-lg btn-light" disabled v-if="creating">
                  <i class="fa fa-spinner fa-spin mr-1"></i> {{ $t('generating_lyrics') }}...
                </button>
                <router-link to="/upgrade?from=lyric-generator-unpublished" v-if="!user.subscription && !hasPublishedMusic" class="btn btn-gradient btn-lg">
                  {{ $t('upgrade_to_pro') }}
                </router-link>
              </div>
            </div>
          </div>

          <div class="card" v-show="result">
            <div class="card-body" ref="lyricContainer">
              <pre class="unsaved-result mb-0 result-container">{{ result }}</pre>
            </div>
            <div class="card-footer" v-if="result && !saved">
              <button type="button" @click="saveSong()" class="btn btn-success btn-lg">{{ $t('save') }}</button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="tab === 'myLyrics'">
        <div class="card mt-4">
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th>{{ $t('title') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!myLyrics.length">
                    <td>
                      {{ $t('any_lyric_yet') }}
                    </td>
                  </tr>
                  <tr v-for="(lyric, index) in myLyrics" v-bind:key="`myLyric_${index}`">
                    <td>
                      <a href="javascript:void(0)" @click="showLyric(lyric)">{{ lyric.title || lyric._id }}</a>
                      <button @click="removeLyric(lyric)" type="button" class="btn btn-xs btn-danger pull-right">
                        <i class="fa fa-times"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div ref="modalLyric" class="modal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content" v-if="selectedLyric">
          <div class="modal-header">
            <h5 class="modal-title fw-bold">
              {{  selectedLyric.title }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <pre>{{ selectedLyric.lyric }}</pre>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              {{ $t('close') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import _ from 'underscore'
import AI from '../services/ai'
import Distributions from '../services/distributions'

export default {
  name: 'LyricGenerator',
  data: function () {
    return {
      hasPublishedMusic: false,
      progress: 0,
      monthlyLyrics: 0,
      maxLyrics: 2,
      tab: 'create',
      word: '',
      result: '',
      creating: false,
      saved: false,
      myLyrics: [],
      lyric: {
        _id: '',
        dedicated: '',
        genre: 'pop',
        language: 'english',
        mood: 'happy',
        chorus: 'no',
        words: []
      },
      selectedLyric: null
    }
  },
  methods: {
    showLyric: function (lyric) {
      this.selectedLyric = lyric
      window.$(this.$refs.modalLyric).modal('show')
    },
    removeLyric: function (lyric) {
      let _confirm = window.confirm(`Remove ${lyric.title}?`)

      if (_confirm) {
        AI.removeLyric(lyric._id).then(() => {
          this.getLyrics()
          this.$notify({ message: this.$t('lyric_removed_successfully') }, 'success', 'fa-check')
        })
      }
    },
    saveSong: function (params) {
      params = params || {}

      if (!params.presave) {
        this.lyric.title = window.prompt(this.$t('song_title'), moment().format('LLL'))

        if (!this.lyric.title) {
          return
        } else {
          this.saved = true
        }
      }

      AI.saveLyric({
        _id: this.lyric._id,
        title: this.lyric.title,
        genre: this.lyric.genre,
        mood: this.lyric.mood,
        lyric: this.result,
        language: this.lyric.language,
        words: this.lyric.words,
        active: !params.presave
      }).then(() => {
        if (!params.presave) {
          this.$notify({ message: this.$t('lyric_stored') }, 'success', 'fa-check')
          this.tab = 'myLyrics'
          this.getLyrics()

          window.gtag && window.gtag('event', `Save Lyric${this.user.subscription ? ' (PRO)' : ''}`, {
            event_category: 'Tools',
            event_label: 'Lyric Generator'
          })
        }
      })
    },
    updateProgress: function () {
      this.progress = parseInt((this.monthlyLyrics / this.maxLyrics) * 100)
    },
    getLyrics: function () {
      this.monthlyLyrics = 0

      AI.getLyrics().then(response => {
        this.myLyrics = response.data.items
        this.monthlyLyrics = response.data.monthly_created

        this.updateProgress()
      })
    },
    addWord: function () {
      if (this.word && this.word.match(/,/)) {
        this.lyric.words = this.word.split(',')
        this.lyric.words.splice(4, this.lyric.words.length)
        this.word = ''
      }

      if (this.lyric.words.length > 3) {
        this.$notify({ message: this.$t('custom_words_limit') }, 'warning', 'fa-exclamation-triangle')
        return
      }

      if (_.contains(this.lyric.words, this.word)) {
        this.word = ''
        return
      }

      this.lyric.words.push(this.word)
      this.word = ''
    },
    removeWord: function (index) {
      this.lyric.words.splice(index, 1)
    },
    createLyrics: function () {
      this.saved = false
      this.creating = true
      this.result = ''
      this.lyric.title = ''

      AI.generateLyrics(this.lyric).then(response => {
        this.result = response.data.message.content
        this.creating = false

        this.saveSong({ presave: true })
        this.monthlyLyrics++
        this.updateProgress()

        window.gtag && window.gtag('event', `Generate Lyric${this.user.subscription ? ' (PRO)' : ''}`, {
          event_category: 'Tools',
          event_label: 'Lyric Generator'
        })

        setTimeout(() => {
          window.$('html, body').animate({
            scrollTop: window.$(this.$refs.lyricContainer).offset().top - 100
          }, 1000)
        }, 100)
      })
    }
  },
  mounted: function () {
    // setTimeout(() => {
    //   if (!this.user.subscription) {
    //     (window.adsbygoogle = window.adsbygoogle || []).push({})
    //   }
    // }, 1000)
  },
  created: function () {
    this.user = this.$user

    if (this.user.subscription) {
      this.maxLyrics = 15
      this.lyric.chorus = 'yes'
    }

    Distributions.getAll().then(response => {
      if (!this.user.subscription && _.find(response.data, item => item.status === 3 || item.status === 2)) {
        this.hasPublishedMusic = true
      } else if (this.user.subscription) {
        this.hasPublishedMusic = true
      }
    })

    this.getLyrics()
  },
  components: {
  }
}
</script>
<style lang="scss" scoped>
.result-container {
  font-size: 14px;
}

.unsaved-result {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/components/LyricGenerator.vue